import { ComponentProps } from 'react';

import NavLink from '../Nav/NavLink';

const SidebarNavLink = (props: ComponentProps<typeof NavLink>) => (
  <NavLink
    color="white"
    textTransform="uppercase"
    _hover={{ color: 'white', textDecor: 'underline' }}
    {...props}
  />
);

export default SidebarNavLink;
